export default function(Site, $) {
  Site.widget('time-selector', {
    _create() {
      this.els = $('[name="_delivery_date"]')
      this.el = $(this.element).add(this.element.next())

      const [id, value] = this.element.val().split('::')
      this.element.attr('value', value)

      const getCurrent = () => {
        const checkedEl = this.els.get().find(el => el.checked)
        return checkedEl && checkedEl.value
      }
      const update = () => {
        const active = this.value && id === this.value
        this.el.css('display', active ? '' : 'none')
        if (!active) {
          this.el.prop('checked', false)
        }
      }
      this.value = getCurrent()
      update()
      this.els.on('change', () => {
        this.value = getCurrent()
        update()
      })
    },
  })
}
